// rem 适配方案
export const setRem = () => {
  // 设计稿宽度
  const designWidth = 1024;
  // 基准大小(16px = 1rem)
  const baseSize = 16;

  const scale = document.documentElement.clientWidth / designWidth;
  // 设置根元素字体大小
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};

// reset rem
export const resetRem = () => {
  document.documentElement.style.fontSize = "16px";
};

// 初始化
export const initRem = () => {
  setRem();
  // 改变窗口大小时重新设置 rem
  window.addEventListener("resize", setRem);
  // 页面显示时重新设置 rem
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      setRem();
    }
  });
};
